import React from "react";
import * as S from "./styles";
export var NewWindow = function NewWindow(e) {
  return React.createElement(S.SVG, Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    "aria-hidden": "true"
  }, e), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, React.createElement("g", {
    strokeWidth: "2"
  }, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
    d: "M13 14L13 17 0 17 0 5 2.962 5",
    transform: "translate(-286 -1676) translate(24 1108) translate(0 392) translate(72) translate(0 176) translate(191 2)"
  }), React.createElement("g", null, React.createElement("path", {
    d: "M3.236 7.986L4.149 2.123M.601 2.802L4.523.255 6.891 3.901",
    transform: "translate(-286 -1676) translate(24 1108) translate(0 392) translate(72) translate(0 176) translate(191 2) rotate(33 5 17.128)"
  }))))))))));
};
export default NewWindow;